import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './ProductsOverview.css';

const ProductsOverview = () => {
  const products = [
    {
      title: '看板・サイン',
      description:
        '店舗看板、施設サイン、案内表示など、設置場所や目的に合わせた看板・サインをご提案いたします。壁面看板、自立看板、箱文字など幅広く対応いたします。',
      path: '/products/signage',
      image: '/images/services/signage.jpg',
    },
    {
      title: 'LED照明',
      description:
        '店舗・施設・屋外空間など、用途に合わせたLED照明をご提案いたします。明るさ、設置環境、演出性、メンテナンス性を考慮して選定いたします。',
      path: '/products/led-lighting',
      image: '/images/services/led-lighting.png',
    },
    {
      title: 'LEDビジョン',
      description:
        '屋内外の映像演出や広告表示に対応するLEDビジョンを、設置場所・視認距離・用途に合わせてご提案いたします。屋外・屋内・特殊形状など各種対応可能です。',
      path: '/products/led-vision',
      image: '/images/services/led-vision.png',
    },
    {
      title: '電光掲示板',
      description:
        '案内・誘導・注意喚起など、目的に合わせた電光掲示板をご提案いたします。駐車場や施設、工場、公共スペースなど、表示内容や設置環境に合わせて対応いたします。',
      path: '/products/electric-board',
      image: '/images/services/electric-board.png',
    },
    {
      title: '防犯カメラ',
      description:
        '店舗・工場・駐車場・施設など、設置環境と目的に合わせて防犯カメラをご提案いたします。録画・遠隔確認・夜間撮影・車両ナンバー確認など、現場に必要な機能を整理して選定いたします。',
      path: '/products/security-camera',
      image: '/images/services/security-camera.png',
    },
    {
      title: 'パーキングシステム',
      description:
        '駐車場の案内表示や満空表示など、利用者に分かりやすいパーキング関連設備をご提案いたします。誘導表示、案内表示、関連機器など幅広く対応します。',
      path: '/products/parking-system',
      image: '/images/services/parking.png',
    },
    {
      title: '緊急出動警報板',
      description:
        '消防署や関連施設向けに、出動時の注意喚起や案内表示を行う警報板・表示設備をご提案いたします。自立型・ポール設置型など各種対応可能です。',
      path: '/products/emergency-board',
      image: '/images/services/emergency-board.png',
    },
    {
      title: 'カスタム金物製作',
      description:
        '現場条件に合わせた架台・ブラケット・取付金物など、各種カスタム金物の製作に対応いたします。現場対応金物、オーダー金物など柔軟に対応いたします。',
      path: '/products/custom-metal',
      image: '/images/services/custom-metal.png',
    },
  ];

  return (
    <div className="products-overview-page">
      <section className="page-hero">
        <div className="container">
          <span className="page-hero-label">PRODUCTS & SERVICES</span>
          <h1>製品・サービス</h1>
          <p>
            施設や店舗、駐車場、工場など、現場の目的や設置環境に合わせて各種製品をご提案いたします。
          </p>
        </div>
      </section>

      <section className="products-overview-section">
        <div className="container">
          <div className="products-list">
            {products.map((product, index) => (
              <div key={index} className="product-item">
                <Link to={product.path} className="product-image">
                  <img
                    src={product.image}
                    alt={product.title}
                    onError={(e) => {
                      e.currentTarget.src = '/images/services/placeholder.jpg';
                    }}
                  />
                  <span className="product-number">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </Link>

                <div className="product-info">
                  <span className="product-code">PRODUCT {String(index + 1).padStart(2, '0')}</span>
                  <h3>{product.title}</h3>
                  <p>{product.description}</p>
                  <Link to={product.path} className="btn-secondary">
                    詳細を見る <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section cta-section-small">
        <div className="container">
          <div className="cta-box">
            <span className="cta-label">CONTACT</span>
            <h2>製品選びでお悩みですか？</h2>
            <p>
              現場に合わせた最適な製品をご提案いたします。お気軽にご相談ください。
            </p>
            <Link to="/contact" className="btn-gold">
              お問い合わせ <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsOverview;